module.exports = __webpack_public_path__ + "static/img/accountdesp.92ddc252.jpg";